/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-duplicates */
import { Fragment, useState, useEffect, useRef, MouseEvent } from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  InputAdornment,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { MdDelete, MdAdd, MdClose } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import ModalCommon from "components/ModalCommon";
import { useZerarPV } from "services/api/SimuladorRepasseAssociativo/put-zerar-pv";
import { useParams } from "react-router-dom";
import { useRemoverSerie } from "services/api/SimuladorRepasseAssociativo/put-remover-serie";
import { useCriarNovaSerie } from "services/api/SimuladorRepasseAssociativo/put-criar-nova-serie";
import { useEditarSerie } from "services/api/SimuladorRepasseAssociativo/put-editar-serie";
import MaterialUI from "material-UI";
import { useGetTiposSeries } from "services/api/SimuladorRepasseAssociativo/get-tipos-series";
import { useCadastrarProposta } from "services/api/SimuladorRepasseAssociativo/post-cadastrar-proposta";
import { toast } from "react-toastify";
import { mostrarAlertaCiencia } from "utils/alertaCiencia";
import { useAlterarProposta } from "services/api/SimuladorRepasseAssociativo/put-alterar-proposta";
import { HiOutlineDocumentArrowUp } from "react-icons/hi2";
import * as S from "./styles";
import DeletarParcelaModal from "../DeletarParcelaModal";
import ZerarPVModal from "../ZerarPVModal";
import ModalPropostaManual from "../ModalPropostaManual";
import ValidacaoProposta from "../ValidacaoProposta";

// Aceita tanto o número cru da API quanto a string pt-BR ("250.000,00") que
// fica no formulário depois de formatada.
const toNumberBr = (value: any) => {
  if (typeof value === "number") return Number.isNaN(value) ? 0 : value;
  if (typeof value !== "string" || value.trim() === "") return 0;

  const numero = parseFloat(value.replace(/\./g, "").replace(",", "."));
  return Number.isNaN(numero) ? 0 : numero;
};

const formatCurrency = (value: any) => {
  const cleanedValue = value.replace(/\D/g, "");
  if (cleanedValue === "00") {
    return "";
  }
  const formattedValue = (Number(cleanedValue) / 100).toFixed(2);
  return `${formattedValue
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
};

type SerieDesmembrada = {
  detalhesParcela: string;
  mes: string;
  qtde: string;
  valorVivaz: string;
  valorCEF: string;
  pagamentoTotal?: string;
};

type RowData = {
  corAviso: string;
  idSerie?: any;
  uniqueId?: any;
  nomeParcela: string;
  tipoParcela: any;
  dataParcela: Date;
  valorMensal: string;
  qtdeParcela: string;
  parcelaCefEstimada: string;
  pagamentoTotalMensal: string;
  aviso: string;
  editavel?: boolean;
  seriesDesmembradas?: SerieDesmembrada[] | null;
  originalData?: RowData;
};

const PARCELA_COLORS: Record<string, string> = {
  Sinal: "#2D5BFF",
  Inicial: "#00C48C",
  Mensal: "#6B7280",
  Anual: "#F59E0B",
  Bônus: "#93C5FD",
  "Bônus Adimplência": "#93C5FD",
  Adimplência: "#7C3AED",
  Única: "#EC4899",
};

const LEGENDA_ITEMS = [
  { label: "Sinal", color: "#2D5BFF" },
  { label: "Inicial", color: "#00C48C" },
  { label: "Mensais (Obra)", color: "#6B7280" },
  { label: "Anuais", color: "#F59E0B" },
  { label: "Bônus", color: "#93C5FD" },
  { label: "Adimplência", color: "#7C3AED" },
  { label: "Única", color: "#EC4899" },
];

const formatMonthYear = (date: Date) => {
  if (!date) return "";
  const validDate = new Date(date);
  if (Number.isNaN(validDate.getTime())) return "";

  const month = validDate
    .toLocaleString("pt-BR", { month: "short" })
    .replace(".", "")
    .toLowerCase();
  const year = validDate.getFullYear().toString().slice(-2);

  return `${month}-${year}`;
};

interface Props {
  dataGerarFluxo: any;
  handleGerarFluxo: any;
  isSucessGerarFluxo: any;
  setFormResumoPagamento: any;
  formResumoPagamento: any;
  setDataEditarSerie: any;
  setSerieEditadaManualmente: any;
  dataValidarProposta: any;
  isLoadingValidarProposta: boolean;
  setProcessando?: (processando: boolean) => void;
}

const PagamentoDetalhado = (props: Props) => {
  const massEditRef = useRef<HTMLDivElement>(null);

  const [rows, setRows] = useState<RowData[]>([]);
  const [verifyFetched, setVerifyFetched] = useState(false);
  const params: any = useParams();
  const [valorDiferenca, setValorDiferenca] = useState(0);
  const [valorDiferencaPorcentagem, setValorDiferencaPorcentagem] = useState(0);
  const [valorTabela, setValorTabela] = useState(0);

  // "Valor Proposta Atual" espelha o "Valor da proposta para unidade" do Resumo
  // de Pagamento. É derivado, não estado: as respostas de gerar-fluxo/editar-serie/
  // zerar-pv trazem `valorVenda`, que divergia desse valor ao atualizar parcelas
  // ou zerar o PV. Sempre acompanha o Resumo.
  const valorPropostaAtual = toNumberBr(
    props.formResumoPagamento?.valorPropostaUnidade
  );
  const { data: dataTiposSeries } = useGetTiposSeries();

  useEffect(() => {
    if (props.isSucessGerarFluxo === true) {
      setVerifyFetched(true);
    }
  }, [props.isSucessGerarFluxo]);

  useEffect(() => {
    if (
      props.dataGerarFluxo &&
      props.dataGerarFluxo.data &&
      props.dataGerarFluxo.data.parcelas
    ) {
      const mappedRows = props.dataGerarFluxo.data.parcelas.map(
        (parcela: any) => {
          const rowData = {
            idSerie: parcela?.idSerie,
            uniqueId: parcela?.uniqueId,
            nomeParcela: parcela?.nomeParcela || "",
            tipoParcela: parcela?.tipoParcela,
            qtdeParcela: parcela?.quantidadeParcelas,
            dataParcela: new Date(parcela.dataParcela),
            valorMensal: parcela?.valorMensal.toString(),
            parcelaCefEstimada: parcela?.parcelaCefEstimada.toString(),
            pagamentoTotalMensal: parcela?.pagamentoTotalMensal.toString(),
            editavel: parcela?.editavel,
            corAviso: parcela?.corAviso,
            aviso: parcela?.aviso || "",
            seriesDesmembradas: parcela?.seriesDesmembradas || null,
          };
          return {
            ...rowData,
            originalData: { ...rowData },
          };
        }
      );
      setRows(mappedRows);
      setSelectedValorMensais(Array(mappedRows.length).fill(false));
      // setSelectedRows(Array(mappedRows.length).fill(false));
    }
  }, [props.dataGerarFluxo]);

  const [selectedValorMensais, setSelectedValorMensais] = useState(
    Array(props.dataGerarFluxo?.data?.parcelas.length).fill(false)
  );

  const [massEditValue, setMassEditValue] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [openModalPropostaManual, setOpenModalPropostaManual] = useState(false);
  const [openModalZerarPV, setOpenModalZerarPV] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const [showPagamentoTotal, setShowPagamentoTotal] = useState(false);

  const toggleExpandRow = (index: number) => {
    setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleMainRowClick = (
    event: MouseEvent<HTMLTableRowElement>,
    index: number,
    hasSubRows: boolean
  ) => {
    if (!hasSubRows) return;

    const target = event.target as HTMLElement;
    const clickedInteractiveElement = target.closest(
      'input, textarea, button, select, label, [role="button"], [role="checkbox"], [role="combobox"], .MuiInputBase-root, .MuiCheckbox-root, .MuiButtonBase-root, .MuiSelect-select, .MuiIconButton-root'
    );

    if (clickedInteractiveElement) return;

    toggleExpandRow(index);
  };

  const getParcelaColor = (nomeParcela: string) => {
    const key = Object.keys(PARCELA_COLORS).find((k) =>
      nomeParcela?.toLowerCase().includes(k.toLowerCase())
    );
    return key ? PARCELA_COLORS[key] : "#6B7280";
  };

  const {
    data: dataEditarSerie,
    mutate: mutateEditarSerie,
    isLoading: isLoadingEditarSerie,
  } = useEditarSerie();

  const handleParcelTypeChange = (event: any, index: any) => {
    const newRows = [...rows];
    newRows[index].tipoParcela = event.target.value;
    newRows[index].nomeParcela =
      dataTiposSeries.find((option: any) => option.id === event.target.value)
        ?.nome || "";
    setRows(newRows);
  };

  const handleValorMensalChange = (event: any, index: any) => {
    const newRows = [...rows];
    newRows[index].valorMensal = formatCurrency(event.target.value);
    setRows(newRows);
  };

  const handleDateChange = (date: any, index: any) => {
    const newRows = [...rows];
    newRows[index].dataParcela = date;
    setRows(newRows);
    setRows([...newRows]);
  };

  const handleSelectedValorMensais = (index: any) => {
    const newSelectedValorMensais = [...selectedValorMensais];
    newSelectedValorMensais[index] = !newSelectedValorMensais[index];
    setSelectedValorMensais(newSelectedValorMensais);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    const newSelectedValorMensais = rows.map((row) => {
      if (row.editavel) {
        return newSelectAll;
      }
      return false;
    });

    setSelectedValorMensais(newSelectedValorMensais);
  };

  const handleMassEditValueChange = (event: any) => {
    setMassEditValue(formatCurrency(event.target.value));
  };

  const handleMassEditSave = () => {
    // const newRows = rows.map((row, index) => {
    //   if (selectedValorMensais[index]) {
    //     return {
    //       ...row,
    //       valorMensal: massEditValue,
    //     };
    //   }
    //   return row;
    // });
    // Não chame `setRows(newRows)` aqui

    const selectedRowsData = rows.filter(
      (_, index) => selectedValorMensais[index]
    );

    const series = selectedRowsData.map((row) => ({
      id: row.idSerie,
      uniqueId: row.uniqueId,
      dtVencimento: row.dataParcela,
      tipoSerie: row.tipoParcela,
    }));

    mutateEditarSerie(
      {
        idLeadCorretor: params.idLeadCorretor,
        idUnidade: params.idUnidade,
        series,
        valorParcelaGeral: parseFloat(
          massEditValue.replace(/\./g, "").replace(",", ".")
        ),
      },
      {
        onSuccess: () => {
          // setRows(newRows);
          props.setSerieEditadaManualmente?.(true);
          setSelectedValorMensais(Array(rows.length).fill(false));
          setSelectAll(false);
          setMassEditValue("");
          // props.handleGerarFluxo(false);
        },
        onError: () => {
          // props.handleGerarFluxo(false);
          setMassEditValue("");
        },
      }
    );
  };

  const handleSaveEdit = () => {
    // Filtra as linhas que foram modificadas
    const modifiedRows = rows.filter((row) => {
      const { originalData } = row;
      if (!originalData) {
        return true; // Se não houver dados originais, consideramos que a linha foi modificada
      }
      // Compara os campos relevantes
      return (
        row.valorMensal !== originalData.valorMensal ||
        row.dataParcela?.getTime() !== originalData.dataParcela?.getTime() ||
        row.tipoParcela !== originalData.tipoParcela
      );
    });

    if (modifiedRows.length === 0) {
      // Se não houver modificações, não precisamos chamar o mutateEditarSerie
      toast.info("Nenhuma alteração foi feita.");
      return;
    }

    const series = modifiedRows.map((row) => ({
      id: row.idSerie,
      uniqueId: row.uniqueId,
      valorParcela: parseFloat(
        row.valorMensal.replace(/\./g, "").replace(",", ".")
      ),
      dtVencimento: row.dataParcela,
      tipoSerie: row.tipoParcela,
    }));

    mutateEditarSerie(
      {
        idLeadCorretor: params.idLeadCorretor,
        idUnidade: params.idUnidade,
        series,
      },
      {
        onSuccess: () => {
          // Atualiza o originalData das linhas modificadas
          // const atoRow = rows.find((row) => row.tipoParcela === 1);
          // if (atoRow) {
          //   props.setFormResumoPagamento({
          //     ...props.formResumoPagamento,
          //     ato: atoRow.valorMensal,
          //   });
          // }
          // const mappedRows = data?.data?.parcelas?.map((parcela: any) => {
          //   const rowData = {
          //     idSerie: parcela?.idSerie,
          //     uniqueId: parcela?.uniqueId,
          //     nomeParcela: parcela?.nomeParcela || "",
          //     tipoParcela: parcela?.tipoParcela,
          //     dataParcela: new Date(parcela.dataParcela),
          //     valorMensal: parcela?.valorMensal.toString(),
          //     parcelaCefEstimada: parcela?.parcelaCefEstimada.toString(),
          //     pagamentoTotalMensal: parcela?.pagamentoTotalMensal.toString(),
          //     editavel: parcela?.editavel,
          //     aviso: parcela?.aviso || "",
          //   };
          //   return {
          //     ...rowData,
          //     originalData: { ...rowData },
          //   };
          // });
          // setRows(mappedRows);
          // const updatedRows = rows.map((row) => {
          //   if (
          //     modifiedRows.find(
          //       (modifiedRow) => modifiedRow.uniqueId === row.uniqueId
          //     )
          //   ) {
          //     return {
          //       ...row,
          //       originalData: { ...row },
          //     };
          //   }
          //   return row;
          // });
          // setRows(updatedRows);
          // props.handleGerarFluxo(false);
          props.setSerieEditadaManualmente?.(true);
        },
        onError: () => {
          // props.handleGerarFluxo(false);
        },
      }
    );
  };

  const handleMassEditCancel = () => {
    setSelectedValorMensais(Array(rows.length).fill(false));
    setSelectAll(false);
    setMassEditValue("");
  };

  // Atualiza os valores do cabeçalho (proposta atual e diferença) e do resumo
  // de pagamento a partir da resposta de uma mutação que recalcula o fluxo.
  const atualizarTotais = (data: any) => {
    const dados = data?.data;
    if (!dados) return;

    if (dados.diferenca !== undefined) {
      setValorDiferenca(dados.diferenca);
    }
    if (dados.diferencaPorcentagem !== undefined) {
      setValorDiferencaPorcentagem(dados.diferencaPorcentagem);
    }
    if (dados.valorTabela !== undefined) {
      setValorTabela(dados.valorTabela);
    }

    const toReal = (value: number) =>
      value?.toLocaleString("pt-br", { minimumFractionDigits: 2 }) || "";

    props.setFormResumoPagamento((prevState: any) => {
      const novoResumo = { ...prevState };

      if (dados.comprometimentoMensaisMed !== undefined) {
        novoResumo.comprometimentoMensaisMedio = toReal(
          dados.comprometimentoMensaisMed
        );
      }
      if (dados.comprometimentoMensaisMax !== undefined) {
        novoResumo.comprometimentoMensaisMaximo = toReal(
          dados.comprometimentoMensaisMax
        );
      }
      if (dados.financiamentoUtilizado !== undefined) {
        novoResumo.financiamentoUtilizado = toReal(
          dados.financiamentoUtilizado
        );
      }
      if (dados.fgtsUtilizado !== undefined) {
        novoResumo.fgtsUtilizado = toReal(dados.fgtsUtilizado);
      }
      if (dados.fgtsSubsidio !== undefined) {
        novoResumo.fgtsSubsidio = toReal(dados.fgtsSubsidio);
      }

      return novoResumo;
    });
  };

  // Remapeia a lista de parcelas a partir da resposta de uma mutação
  // (editar série, zerar PV) e propaga o resultado para a tela pai.
  const atualizarListaSeries = (data: any) => {
    if (!data?.data?.parcelas) return;

    const mappedRows = data.data.parcelas.map((parcela: any) => {
      const rowData = {
        idSerie: parcela?.idSerie,
        uniqueId: parcela?.uniqueId,
        nomeParcela: parcela?.nomeParcela || "",
        tipoParcela: parcela?.tipoParcela,
        dataParcela: new Date(parcela.dataParcela),
        qtdeParcela: parcela?.quantidadeParcelas,
        valorMensal: parcela?.valorMensal.toString(),
        parcelaCefEstimada: parcela?.parcelaCefEstimada.toString(),
        pagamentoTotalMensal: parcela?.pagamentoTotalMensal.toString(),
        corAviso: parcela?.corAviso,
        editavel: parcela?.editavel,
        aviso: parcela?.aviso || "",
        seriesDesmembradas: parcela?.seriesDesmembradas || null,
      };
      return {
        ...rowData,
        originalData: { ...rowData },
      };
    });
    setRows(mappedRows);
    atualizarTotais(data);
    // Passa os dados atualizados para o componente pai
    if (props.setDataEditarSerie) {
      props.setDataEditarSerie(data);
    }
  };

  const possuiParcelaSelecionada = selectedValorMensais.some(
    (value: boolean) => value === true
  );

  const { mutate: mutateZerarPV, isLoading: isLoadingZerarPV } = useZerarPV();

  const handleZerarPV = () => {
    const uniqueIds = rows
      .filter((_, index) => selectedValorMensais[index])
      .map((row) => Number(row.uniqueId))
      .filter((uniqueId) => !Number.isNaN(uniqueId));

    if (uniqueIds.length === 0) {
      toast.info("Selecione ao menos uma parcela para zerar o PV.");
      return;
    }

    mutateZerarPV(
      {
        idLeadCorretor: params.idLeadCorretor,
        idUnidade: params.idUnidade,
        uniqueIds,
      },
      {
        onSuccess: (data) => {
          setOpenModalZerarPV(false);
          setSelectedValorMensais(Array(rows.length).fill(false));
          setSelectAll(false);
          setMassEditValue("");
          props.setSerieEditadaManualmente?.(true);
          atualizarListaSeries(data);
        },
      }
    );
  };

  const { mutate: mutateCadastrarProposta, status: statusCadastrarProposta } =
    useCadastrarProposta();

  const { mutate: mutateAlterarProposta, status: statusAlterarProposta } =
    useAlterarProposta();

  // Avisa a tela para abrir o loading em tela cheia. Só entram aqui as ações
  // que realmente chamam a API: editar uma série no campo e sair dele não
  // dispara nada, então aquela edição continua local e sem overlay.
  const { setProcessando } = props;

  const processandoPagamentoDetalhado =
    isLoadingEditarSerie ||
    isLoadingZerarPV ||
    statusCadastrarProposta === "loading" ||
    statusAlterarProposta === "loading";

  useEffect(() => {
    setProcessando?.(processandoPagamentoDetalhado);
  }, [processandoPagamentoDetalhado, setProcessando]);

  // Desmontar a seção com uma mutação em andamento deixaria o overlay preso.
  useEffect(() => () => setProcessando?.(false), [setProcessando]);

  const handleCadastrarProposta = () => {
    const modified = rows.some((row) => {
      const { originalData } = row;
      if (!originalData) {
        return true;
      }
      return (
        row.valorMensal !== originalData.valorMensal ||
        row.dataParcela?.getTime() !== originalData.dataParcela?.getTime() ||
        row.tipoParcela !== originalData.tipoParcela
      );
    });

    // if (Math.abs(valorDiferenca) > 0.9) {
    //   toast.error(
    //     "Atenção: Para concluir é necessário zerar a diferença da Proposta"
    //   );
    //   return;
    // }

    if (modified) {
      mostrarAlertaCiencia({
        titulo: "Alterações não salvas",
        mensagem:
          "Você precisa salvar as alterações antes de concluir a proposta.",
      });
      return;
    }
    if (params.action === "editable") {
      mutateAlterarProposta(
        {
          idUnidade: params.idUnidade,
          idLeadCorretor: params.idLeadCorretor,
          idOportunidade: params.idOportunidade,
        },
        {
          onSuccess: () => {
            localStorage.setItem(
              "leadTabData",
              JSON.stringify({
                idLead: params.idLeadCorretor, // ou props.idLead, dependendo de qual for o lead correto
                tabValue: 1,
              })
            );
            window.location.pathname = `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params?.numeroCotacao}`;
          },
        }
      );
    } else {
      mutateCadastrarProposta(
        {
          idUnidade: params.idUnidade,
          idLeadCorretor: params.idLeadCorretor,
        },
        {
          onSuccess: (data) => {
            localStorage.setItem(
              "leadTabData",
              JSON.stringify({
                idLeadCorretor: params.idLeadCorretor, // ou props.idLead
                tabValue: 1,
              })
            );
            window.location.pathname = `/lead-detail/${params.idLeadCorretor}/proposition-detail/${data?.data?.numeroCotacao}`;
          },
        }
      );
    }
  };

  useEffect(() => {
    if (dataEditarSerie) {
      atualizarListaSeries(dataEditarSerie);
    }
  }, [dataEditarSerie]);

  useEffect(() => {
    if (props.dataGerarFluxo?.data?.diferenca !== undefined) {
      setValorDiferenca(props.dataGerarFluxo?.data?.diferenca);
    }
    if (props.dataGerarFluxo?.data?.diferencaPorcentagem !== undefined) {
      setValorDiferencaPorcentagem(
        props.dataGerarFluxo?.data?.diferencaPorcentagem
      );
      if (props.dataGerarFluxo?.data?.valorTabela !== undefined) {
        setValorTabela(props.dataGerarFluxo?.data?.valorTabela);
      }
    }
  }, [props.dataGerarFluxo]);

  useEffect(() => {
    if (selectedValorMensais.some((selected) => selected)) {
      if (massEditRef.current) {
        massEditRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [selectedValorMensais]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBR}>
      {verifyFetched ? (
        <S.Container>
          <S.Row style={{ justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <S.Title>Simulação Pagamento Detalhado</S.Title>
              {isLoadingEditarSerie ? (
                <MaterialUI.CircularProgress
                  style={{ color: "blue" }}
                  size={22}
                />
              ) : null}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <S.Title>Valor Proposta Atual: </S.Title>
              <S.DifContainerValue>
                <S.Title
                  style={{
                    color: "#333333",
                  }}
                >
                  R${" "}
                  {valorPropostaAtual.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                  })}{" "}
                </S.Title>
              </S.DifContainerValue>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <S.Title>Diferença: </S.Title>
              <S.DifContainer
                verifyDiff={valorDiferenca?.toString()?.includes("-")}
              >
                <S.Title
                  style={{
                    color: valorDiferenca?.toString()?.includes("-")
                      ? "#f43636"
                      : "#4caf50",
                  }}
                >
                  R${" "}
                  {valorDiferenca.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                  })}{" "}
                  {/* |{" "}
                  {valorDiferencaPorcentagem.toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                  })}{" "}
                  % */}
                </S.Title>
              </S.DifContainer>
            </div>
          </S.Row>
          <S.LegendContainer>
            <S.LegendItem
              style={{ fontWeight: 600, fontSize: "14px", color: "#333" }}
            >
              LEGENDA:
            </S.LegendItem>
            {LEGENDA_ITEMS.map((item) => (
              <S.LegendItem key={item.label}>
                <S.LegendDot style={{ backgroundColor: item.color }} />
                <span>{item.label}</span>
              </S.LegendItem>
            ))}
            <S.LegendActions>
              <S.ToggleButton onClick={() => setOpenPreviewModal(true)}>
                <AiOutlineEye size={16} />
                Preview
              </S.ToggleButton>
              <S.ToggleButton
                onClick={() => setShowPagamentoTotal((prev) => !prev)}
              >
                {showPagamentoTotal ? (
                  <AiOutlineEyeInvisible size={16} />
                ) : (
                  <AiOutlineEye size={16} />
                )}
                {showPagamentoTotal ? "Ocultar dados" : "Exibir dados"}
              </S.ToggleButton>
            </S.LegendActions>
          </S.LegendContainer>
          <S.BodyContainer>
            <S.TableContainerStyled>
              <Table>
                <TableHead sx={{ backgroundColor: "#F2F4F8" }}>
                  <TableRow>
                    <S.StyledTableCellHeader
                      sx={{
                        paddingLeft: "24px !important",
                        paddingRight: "24px !important",
                      }}
                    >
                      <S.TitleTableHeader>Parcelas</S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                    <S.StyledTableCellHeader>
                      <S.TitleTableHeader>Início em</S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                    <S.StyledTableCellHeader>
                      <S.TitleTableHeader>Qtde.</S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                    <S.StyledTableCellHeader>
                      <Checkbox
                        size="small"
                        disableRipple
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </S.StyledTableCellHeader>
                    <S.StyledTableCellHeader>
                      <S.TitleTableHeader>Parcela Vivaz</S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                    <S.StyledTableCellHeader>
                      <S.TitleTableHeader>
                        Média Parcela CEF Estimada
                      </S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                    {showPagamentoTotal && (
                      <S.StyledTableCellHeader>
                        <S.TitleTableHeader>
                          Média Pagto. Estimado Total
                        </S.TitleTableHeader>
                      </S.StyledTableCellHeader>
                    )}
                    <S.StyledTableCellHeader>
                      <S.TitleTableHeader>Avisos</S.TitleTableHeader>
                    </S.StyledTableCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => {
                    const parcelaColor = getParcelaColor(row.nomeParcela);
                    const parcelaHoverColor = `${parcelaColor}26`;
                    const hasSubRows =
                      row.seriesDesmembradas &&
                      row.seriesDesmembradas.length > 0;
                    const isExpanded = expandedRows[index];

                    return (
                      <>
                        <S.HoverTableRow
                          key={index}
                          $hoverColor={parcelaHoverColor}
                          onClick={(event) =>
                            handleMainRowClick(
                              event,
                              index,
                              hasSubRows ?? false
                            )
                          }
                          style={{ cursor: hasSubRows ? "pointer" : "default" }}
                        >
                          <S.StyledTableCellBody
                            borderColor={parcelaColor}
                            style={{ minWidth: "150px" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {hasSubRows && (
                                <S.ExpandArrow isExpanded={isExpanded}>
                                  <IoIosArrowDown size={16} />
                                </S.ExpandArrow>
                              )}
                              <S.StyledDropdown
                                value={row.tipoParcela}
                                onChange={(e) =>
                                  handleParcelTypeChange(e, index)
                                }
                                displayEmpty
                                disabled
                                IconComponent={IoIosArrowDown}
                                style={{
                                  marginLeft: hasSubRows ? 0 : 10,
                                  width: "30px",
                                }}
                              >
                                {dataTiposSeries?.map((option: any) => {
                                  const isSelected =
                                    option?.id === row.tipoParcela;
                                  if (
                                    option?.apresentar === false &&
                                    !isSelected
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <MenuItem
                                      key={option?.id}
                                      value={option?.id}
                                      disabled={option?.parametro === true}
                                    >
                                      {option?.nome}
                                    </MenuItem>
                                  );
                                })}
                              </S.StyledDropdown>
                            </div>
                          </S.StyledTableCellBody>
                          <S.StyledTableCellBody>
                            <DatePicker
                              views={["year", "month"]}
                              value={row.dataParcela}
                              onChange={(date: any) =>
                                handleDateChange(date, index)
                              }
                              label={" "}
                              disabled={row.nomeParcela !== "Anual"}
                              inputFormat="MMM-yy"
                              minDate={new Date()}
                              renderInput={(params) => {
                                return (
                                  <S.StyledTextFieldData
                                    InputLabelProps={{ shrink: false }}
                                    {...params}
                                    variant="outlined"
                                    fullWidth
                                    disabled={row.nomeParcela !== "Anual"}
                                    active={row.dataParcela === null}
                                  />
                                );
                              }}
                            />
                          </S.StyledTableCellBody>
                          <S.StyledTableCellBody>
                            <S.StyledTextField
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              fullWidth
                              disabled
                              value={row.qtdeParcela}
                              style={{
                                width: "52px",
                              }}
                              InputProps={{
                                inputProps: {
                                  style: {
                                    textAlign: "center",
                                  },
                                },
                              }}
                            />
                          </S.StyledTableCellBody>
                          <S.StyledTableCellBody>
                            <Checkbox
                              size="small"
                              disableRipple
                              disabled={!row.editavel}
                              checked={selectedValorMensais[index]}
                              onChange={() => handleSelectedValorMensais(index)}
                            />
                          </S.StyledTableCellBody>
                          <S.StyledTableCellBody style={{ minWidth: "200px" }}>
                            <S.StyledTextField
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              fullWidth
                              disabled={!row.editavel}
                              onChange={(e) =>
                                handleValorMensalChange(e, index)
                              }
                              value={row.valorMensal}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    R$
                                  </InputAdornment>
                                ),
                                inputProps: {
                                  style: {
                                    textAlign: "right",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  },
                                },
                              }}
                            />
                          </S.StyledTableCellBody>
                          <S.StyledTableCellBody
                            style={{ minWidth: "160px", width: "160px" }}
                          >
                            <S.StyledTextField
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              fullWidth
                              disabled
                              value={row.parcelaCefEstimada}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    R$
                                  </InputAdornment>
                                ),
                                inputProps: {
                                  style: { textAlign: "right" },
                                },
                              }}
                            />
                          </S.StyledTableCellBody>
                          {showPagamentoTotal && (
                            <S.StyledTableCellBody
                              style={{ minWidth: "160px", width: "160px" }}
                            >
                              <S.StyledTextField
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                fullWidth
                                disabled
                                value={row.pagamentoTotalMensal}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      R$
                                    </InputAdornment>
                                  ),
                                  inputProps: {
                                    style: { textAlign: "right" },
                                  },
                                }}
                              />
                            </S.StyledTableCellBody>
                          )}
                          <S.StyledTableCellBody style={{ minWidth: "225px" }}>
                            {row.aviso ? (
                              <S.AvisoTag corAviso={row.corAviso}>
                                {row.aviso}
                              </S.AvisoTag>
                            ) : null}
                          </S.StyledTableCellBody>
                        </S.HoverTableRow>
                        {hasSubRows && isExpanded && (
                          <>
                            <TableRow>
                              <S.SubRowHeaderCell borderColor={parcelaColor}>
                                Detalhe da Parcela
                              </S.SubRowHeaderCell>
                              <S.SubRowHeaderCell>Mês</S.SubRowHeaderCell>
                              <S.SubRowHeaderCell>Qtde.</S.SubRowHeaderCell>
                              <S.SubRowHeaderCell />
                              <S.SubRowHeaderCell>
                                Valor Vivaz
                              </S.SubRowHeaderCell>
                              <S.SubRowHeaderCell>Valor CEF</S.SubRowHeaderCell>
                              {/* {showPagamentoTotal && (
                                <S.SubRowHeaderCell>
                                  Pagamento Total
                                </S.SubRowHeaderCell>
                              )} */}
                              <S.SubRowHeaderCell />
                            </TableRow>
                            {(row.seriesDesmembradas || []).map(
                              (sub, subIndex) => (
                                <S.HoverTableRow
                                  key={`${index}-sub-${subIndex}`}
                                  $hoverColor={parcelaHoverColor}
                                >
                                  <S.SubRowCell
                                    borderColor={parcelaColor}
                                    style={{ paddingLeft: "32px" }}
                                  >
                                    {sub.detalhesParcela}
                                  </S.SubRowCell>
                                  <S.SubRowCell>{sub.mes}</S.SubRowCell>
                                  <S.SubRowCell>{sub.qtde}</S.SubRowCell>
                                  <S.SubRowCell />
                                  <S.SubRowCell>
                                    R$ {sub.valorVivaz}
                                  </S.SubRowCell>
                                  <S.SubRowCell>R$ {sub.valorCEF}</S.SubRowCell>
                                  {/* {showPagamentoTotal && (
                                    <S.SubRowCell>
                                      {sub.pagamentoTotal
                                        ? `R$ ${sub.pagamentoTotal}`
                                        : `R$ ${row.pagamentoTotalMensal}`}
                                    </S.SubRowCell>
                                  )} */}
                                  <S.SubRowCell />
                                </S.HoverTableRow>
                              )
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </S.TableContainerStyled>
            <ValidacaoProposta
              dataValidarProposta={props.dataValidarProposta}
              isLoadingValidarProposta={props.isLoadingValidarProposta}
            />
            <S.Row>
              <S.Column style={{ flex: 0 }}>
                <S.Button
                  style={{
                    width: "270px",
                    backgroundColor: "#EAEFFF",
                    color: "#2D5BFF",
                  }}
                  onClick={() => setOpenModalZerarPV(true)}
                  disabled={
                    props.dataGerarFluxo?.data?.editavel === false ||
                    !possuiParcelaSelecionada
                  }
                >
                  Zerar PV
                </S.Button>
              </S.Column>
            </S.Row>
            {possuiParcelaSelecionada ? (
              <S.Row ref={massEditRef}>
                <S.Column>
                  <S.StyledTextField
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    fullWidth
                    onChange={handleMassEditValueChange}
                    value={massEditValue}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">R$</InputAdornment>
                      ),
                      inputProps: { style: { textAlign: "right" } },
                    }}
                  />
                </S.Column>
                <S.Column style={{ flex: 0 }}>
                  <S.Button
                    style={{ width: "270px", marginTop: "4px" }}
                    onClick={handleMassEditSave}
                    disabled={massEditValue === ""}
                  >
                    {isLoadingEditarSerie ? (
                      <MaterialUI.CircularProgress
                        size={22}
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      "Salvar"
                    )}
                  </S.Button>
                </S.Column>
                <S.Column style={{ flex: 0 }}>
                  <S.Button
                    style={{
                      width: "270px",
                      marginTop: "4px",
                      backgroundColor: "#EAEFFF",
                      color: "#2D5BFF",
                    }}
                    onClick={handleMassEditCancel}
                  >
                    Cancelar
                  </S.Button>
                </S.Column>
              </S.Row>
            ) : (
              <>
                <S.Row>
                  <S.Column>
                    <S.Button
                      style={{
                        backgroundColor: "#1B5E20",
                        color: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                      onClick={() => setOpenModalPropostaManual(true)}
                    >
                      <HiOutlineDocumentArrowUp size={20} />
                      Proposta Manual
                    </S.Button>
                  </S.Column>
                  <S.Column>
                    <S.Button
                      style={{ backgroundColor: "#EAEFFF", color: "#2D5BFF" }}
                      onClick={handleSaveEdit}
                      disabled={props.dataGerarFluxo?.data?.editavel === false}
                    >
                      {isLoadingEditarSerie ? (
                        <MaterialUI.CircularProgress
                          size={22}
                          style={{ color: "#2D5BFF" }}
                        />
                      ) : (
                        "Salvar Alterações/Recalcular"
                      )}
                    </S.Button>
                  </S.Column>
                  <S.Column>
                    <S.Button
                      onClick={() => {
                        handleCadastrarProposta();
                      }}
                      disabled={props.dataGerarFluxo?.data?.editavel === false}
                    >
                      {statusCadastrarProposta === "loading" ||
                      statusAlterarProposta === "loading" ? (
                        <MaterialUI.CircularProgress
                          size={22}
                          style={{ color: "#fff" }}
                        />
                      ) : (
                        "Concluir"
                      )}
                    </S.Button>
                  </S.Column>
                </S.Row>
                <ModalCommon
                  open={openModalPropostaManual}
                  setOpenModal={setOpenModalPropostaManual}
                  onClose={() => setOpenModalPropostaManual(false)}
                >
                  <ModalPropostaManual
                    onClose={() => setOpenModalPropostaManual(false)}
                  />
                </ModalCommon>
              </>
            )}
            <ModalCommon
              open={openModalZerarPV}
              setOpenModal={setOpenModalZerarPV}
              onClose={() => setOpenModalZerarPV(false)}
            >
              <ZerarPVModal
                onClose={() => setOpenModalZerarPV(false)}
                handleZerarPV={handleZerarPV}
                isLoadingZerarPV={isLoadingZerarPV}
              />
            </ModalCommon>
          </S.BodyContainer>
          {openPreviewModal && (
            <S.PreviewOverlay>
              <S.PreviewHeader>
                <S.PreviewTitleGroup>
                  <S.PreviewIcon>
                    <AiOutlineEye size={18} />
                  </S.PreviewIcon>
                  <div>
                    <S.PreviewTitle>
                      Preview da Simulação Detalhada
                    </S.PreviewTitle>
                    <S.PreviewSubtitle>
                      Visualização completa do fluxo
                    </S.PreviewSubtitle>
                  </div>
                </S.PreviewTitleGroup>
                <S.PreviewCloseButton
                  type="button"
                  onClick={() => setOpenPreviewModal(false)}
                  aria-label="Fechar preview"
                >
                  <MdClose size={22} />
                </S.PreviewCloseButton>
              </S.PreviewHeader>

              <S.PreviewContent>
                <S.PreviewSummary>
                  <S.PreviewSummaryValues>
                    <S.PreviewSummaryItem>
                      <span>Valor Proposta Atual</span>
                      <strong>
                        R${" "}
                        {valorPropostaAtual.toLocaleString("pt-br", {
                          minimumFractionDigits: 2,
                        })}
                      </strong>
                    </S.PreviewSummaryItem>
                    <S.PreviewSummaryItem>
                      <span>Diferença</span>
                      <strong
                        style={{
                          color: valorDiferenca?.toString()?.includes("-")
                            ? "#f43636"
                            : "#4caf50",
                        }}
                      >
                        R${" "}
                        {valorDiferenca.toLocaleString("pt-br", {
                          minimumFractionDigits: 2,
                        })}
                      </strong>
                    </S.PreviewSummaryItem>
                  </S.PreviewSummaryValues>
                  <S.PreviewLegend>
                    <span>Legenda de cores</span>
                    <div>
                      {LEGENDA_ITEMS.map((item) => (
                        <S.LegendItem key={item.label}>
                          <S.LegendDot
                            style={{ backgroundColor: item.color }}
                          />
                          <span>{item.label}</span>
                        </S.LegendItem>
                      ))}
                    </div>
                  </S.PreviewLegend>
                </S.PreviewSummary>

                <S.PreviewTableWrapper>
                  <S.PreviewTable>
                    <thead>
                      <tr>
                        <th>Parcelas</th>
                        <th>Mês/Início</th>
                        <th>Qtde.</th>
                        <th>Parcela Vivaz</th>
                        <th>Parcela CEF</th>
                        <th>Total Estimado</th>
                        <th>Avisos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => {
                        const parcelaColor = getParcelaColor(row.nomeParcela);
                        const subRows = row.seriesDesmembradas || [];

                        return (
                          <Fragment key={`preview-${index}`}>
                            <S.PreviewMainRow key={`preview-${index}`}>
                              <td>
                                <S.PreviewParcelaName $color={parcelaColor}>
                                  {row.nomeParcela}
                                </S.PreviewParcelaName>
                              </td>
                              <td>{formatMonthYear(row.dataParcela)}</td>
                              <td>
                                <S.PreviewBadge>
                                  {row.qtdeParcela}
                                </S.PreviewBadge>
                              </td>
                              <td>R$ {row.valorMensal}</td>
                              <td>R$ {row.parcelaCefEstimada}</td>
                              <td>R$ {row.pagamentoTotalMensal}</td>
                              <td>
                                {row.aviso ? (
                                  <S.AvisoTag corAviso={row.corAviso}>
                                    {row.aviso}
                                  </S.AvisoTag>
                                ) : null}
                              </td>
                            </S.PreviewMainRow>
                            {subRows.map((sub, subIndex) => (
                              <S.PreviewSubRow
                                key={`preview-${index}-sub-${subIndex}`}
                              >
                                <td>{sub.detalhesParcela}</td>
                                <td>{sub.mes}</td>
                                <td>{sub.qtde}</td>
                                <td>R$ {sub.valorVivaz}</td>
                                <td>R$ {sub.valorCEF}</td>
                                {/* <td>
                                  {sub.pagamentoTotal
                                    ? `R$ ${sub.pagamentoTotal}`
                                    : `R$ ${row.pagamentoTotalMensal}`}
                                </td> */}
                                <td />
                              </S.PreviewSubRow>
                            ))}
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </S.PreviewTable>
                </S.PreviewTableWrapper>
              </S.PreviewContent>
            </S.PreviewOverlay>
          )}
        </S.Container>
      ) : null}
    </LocalizationProvider>
  );
};

export default PagamentoDetalhado;
